var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"color-selector outer",class:{ active: _vm.active }},[_c('div',{staticClass:"inner",style:({ backgroundColor: _vm.color })})])
}
var staticRenderFns = []

export { render, staticRenderFns }